/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import BetForm from './betForm'
import * as stringParser from '../../util/string.util'
import { calculateExpouser } from '../../util/expouser.util'
import Currency from './currency'
import Volume from './volume'
import { DemoBetDelay } from '../../configs/casinoShowList';
export default class WebMarket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            runner_name: "",
            bid_at: "",
            bid_amount: 0,
            book: {},
            market: {},
            selectionId: "",
            mktMsg:""
        };
        this.onChange = this.onChange.bind(this);
        this.changeBid = this.changeBid.bind(this);
    }
    selectBid(runner_name, bid_at, market_id, bid_for, team) {
        localStorage.setItem("betForm", JSON.stringify({ runner_name: runner_name, bid_at: bid_at, bid_amount: 0, selectionId: team.id.toString() }))
        this.setState({ runner_name: runner_name, bid_at: bid_at, bid_amount: 0, selectionId: team.id.toString() }, () => {
            this.props.betForm(market_id, bid_for, "clicked")
        })
    }
    componentWillUnmount() {
        this.props.socket.off("market_room")
    }
    componentDidMount() {
        const socket = this.props.socket;
        if (this.props.market.bettingType === "BOOKMAKER") {
            this.props.market.runners = this.props.market.runners.sort(function (a, b) {
                return parseFloat(a.id) - parseFloat(b.id);
            });
            if (!!this.props.market.metadata && !!this.props.market.metadata.book) {
                this.props.market.metadata.book.runners = this.props.market.metadata.book.runners.sort(function (a, b) {
                    return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                });
            }
        }
        this.setState({ market: this.props.market, book: !!this.props.feedBooks[this.props.market.marketId] ? this.props.feedBooks[this.props.market.marketId] : this.props.market.marketBook })
        if (!this.props.market.metadata || !this.props.market.metadata.book || this.props.market.metadata.book.status === "CLOSED" || this.props.market.metadata.book.status === "INACTIVE") {
            return false
        }
        if (localStorage.getItem("betExpo")) {
            this.setState({ expo: JSON.parse(localStorage.getItem("betExpo")) })
        }
        if (this.props.subscribedMarkets.indexOf(this.props.market.marketId) === -1) {
            if (this.props.subscriptions.market_room.indexOf(this.props.market.marketId) === -1) {
                socket.emit('market_room', this.props.market.marketId)
                this.props.subscribe('market_room', this.props.market.marketId)
                this.props.updateSubscribedMarkets(this.props.market.marketId)
            }
        }
        let stream = ""
        socket.on("message_room", data => {
            let objData = JSON.parse(data)
            if(!!objData.command && objData.command === 'MARKET_MESSAGE' && !!objData.payload && objData.payload.marketId ===  this.props.market.marketId){
               this.setState({mktMsg:objData.payload.message})
               if(this.props.updateMktMsg){
                   this.props.updateMktMsg(objData.payload)
               }
            }
        });
        socket.on("market_room", data => {
            if (stream !== data) {
                stream = data
                let newBook = null
                try {
                    newBook = stringParser.deSrlz(data)
                } catch {
                    let baseData = {
                        marketId: this.props.market.marketId,
                        status: "OPEN",
                        runners: []
                    }
                    this.state.market.runners.forEach((rnr) => {
                        let data = { "selectionId": rnr.id.toString(), "status": "ACTIVE", "back": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }], "lay": [{ "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }, { "price": "0", "size": "0", "line": "0" }] }
                        baseData.runners.push(data)
                    })
                    newBook = baseData
                }
                if (this.props.market.bettingType === "BOOKMAKER") {
                    newBook.runners = newBook.runners.sort(function (a, b) {
                        return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                    });
                }
                if (this.props.market.marketId === newBook.marketId) {
                    this.props.updateBook(this.props.market.marketId, newBook)
                    let curBook = this.state.book
                    curBook.runners.forEach((rn, i) => {
                        let nrn = newBook.runners[i]
                        rn.back.forEach((bk, j) => {
                            if (!!nrn.back[j]) {
                                if (!!nrn && bk.price !== nrn.back[j].price) {
                                    nrn.back[j].has_blink = true
                                } else {
                                    nrn.back[j].has_blink = false
                                }
                            }
                        })
                        rn.lay.forEach((ly, k) => {
                            if (!!nrn.lay[k]) {
                                if (!!nrn && ly.price !== nrn.lay[k].price) {
                                    nrn.lay[k].has_blink = true
                                } else {
                                    nrn.lay[k].has_blink = false
                                }
                            }
                        })
                        newBook.runners[i] = nrn
                    });
                    this.setState({ book: newBook }, () => {
                        setTimeout(() => {
                            curBook.runners.forEach((rn, i) => {
                                let nrn = newBook.runners[i]
                                rn.back.forEach((bk, j) => {
                                    if (!!nrn.back[j]) {
                                        nrn.back[j].has_blink = false
                                    }
                                })
                                rn.lay.forEach((ly, k) => {
                                    if (!!nrn.lay[k]) {
                                        nrn.lay[k].has_blink = false
                                    }
                                })
                                newBook.runners[i] = nrn
                            });
                            this.setState({ book: newBook })
                        }, 500)
                    })
                }
            }
        });
        socket.on('disconnect', () => {
            socket.emit('market_room', this.props.market.marketId)
        })
    }
    changeBid(val) {
        this.setState({ bid_amount: val })
    }
    updateExpo(exp) {
        this.setState({ expo: {} }, () => {
            this.setState({ expo: exp })
        })
        localStorage.setItem("betExpo", JSON.stringify(exp))
    }
    onChange(e) {
        this.changeBid(e.target.value)
    }
    thexInputClick(val) {
        let cur_amount = this.state.bid_amount.toString()
        let new_amount = ""
        if (val !== "back") {
            new_amount = cur_amount + val.toString()
        } else {
            new_amount = cur_amount.substring(0, cur_amount.length - 1);
        }
        this.changeBid(new_amount)
    }
    userPropertyUpdate() {
        let market = this.props.market;
        if (this.props.market.bettingType === "BOOKMAKER") {
            this.props.market.runners = this.props.market.runners.sort(function (a, b) {
                return parseFloat(a.id) - parseFloat(b.id);
            });
            if (!!this.props.market.metadata && !!this.props.market.metadata.book) {
                this.props.market.metadata.book.runners = this.props.market.metadata.book.runners.sort(function (a, b) {
                    return parseFloat(a.selectionId) - parseFloat(b.selectionId);
                });
            }
        }
        let userMktCondition = localStorage.getItem("accountData")
        userMktCondition = JSON.parse(userMktCondition)
        if (market.maxBet === 0) {
            market.maxBet = userMktCondition.maxBet
        } else if (userMktCondition.maxBet === 0) {
            market.maxBet = market.marketCondition.maxBet
        } else {
            market.maxBet = market.marketCondition.maxBet
        }
        market.betDelay = Math.max(market.betDelay, userMktCondition.betDelay)
        return market
    }
    addBetFn(dt, mkt){
        dt.marketId = mkt.marketId; 
        dt.selectionId = this.state.selectionId; 

        const prfdt = JSON.parse(localStorage.getItem('profData'));
        if(prfdt?.role === 'DemoClient'){
            this.props.togglebetLoader()    
                setTimeout(() => {    
                    let price = dt.price
                    this.state.book.runners.forEach((itm)=>{
                        if(itm.selectionId === dt.selectionId){
                            price = itm[dt.bet_for][0].price;
                        }
                    })
                    dt.price = price;
                    this.props.addBet(dt)
                }, DemoBetDelay);
        } else {
            this.props.addBet(dt)
        }
    }
    render() {
        let market = this.userPropertyUpdate();
        let book = this.state.book
        let mktBets = []
        if (this.props.curBets) {
            mktBets = this.props.curBets.filter((bet, i) => {
                return bet.marketId === this.props.market.marketId
            })
        }
        let marketExpo = calculateExpouser(market, market.runners[0].marketId, "back", 0, 0, mktBets)
        let multiplayFector = market.marketCondition.volume
        let currencyConversion = JSON.parse(localStorage.getItem('profData')).currencyConversion
        return (
            <>
                {!!book && book.status !== "CLOSED" && book.status !== "INACTIVE" &&
                    <div className="game-wrap col3 mb-1 pl-3 pr-2">
                        <div className='row pb-1'>
                            {!!market.runners && market.runners.map((runner, i) => {
                                let runner_bk = !!this.state.book && this.state.book !== {} && !!this.state.book.runners && this.state.book.runners.length > 0 ? this.state.book.runners.filter((r) => { return r.selectionId.toString() === runner.id.toString() })[0] : null
                                runner.name = market.runners[i].name
                                let is_active = book.status === "OPEN" && runner_bk.status === "ACTIVE" ? true : false
                                return (
                                    <>
                                        {!!runner_bk && runner_bk.status !== "REMOVED" && <div className={market.runners.length <=2 ?'col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6':'col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4'}>
                                            <div className='d-inline-flex w-100 lottery-p-2 odds'>
                                                <div className='d-inline-block lottery-w75 lottery-inplay v-align-top'>{runner.name}
                                                    {mktBets.length > 0 && <Currency key={"mktexpo"} classPropName={"match-odds font-weight-bold"} amount={marketExpo[runner.id]} showColor={true} />}
                                                    <span className={"float-right"} style={{ marginBottom: '15px', marginRight: '1rem', position: 'absolute', top: '5px', right: '35%' }}>
                                                        {!!this.state.expo && this.state.expo[runner.id] && this.props.selected_market === this.props.market.marketId ? <Currency key={"expo"} classPropName={"match-odds font-weight-bold"} amount={this.state.expo[runner.id]} showColor={true} /> : ""}
                                                    </span>
                                                </div>
                                                <div className={book.status === "OPEN" && runner_bk.status === "ACTIVE" ? book.sportingEvent === true ? 'd-inline-block lottery-w25 lottery-inplay btn-back ballrunning-winnerodds' : 'd-inline-block lottery-w25 lottery-inplay btn-back' : 'd-inline-block lottery-w25 lottery-inplay btn-back suspended-winnerodds'}>
                                                    {!!runner_bk.back && <div onClick={() => { !!runner_bk.back[0] && !!runner_bk.back[0].price && runner_bk.back[0].price > 0 && !market.betLock && this.selectBid(runner.name, runner_bk.back[0].price, market.marketId, "back", runner) }}>
                                                        <a className="btn-back border-bottom1 w-100 text-center d-block font-weight-bold " side="Back" >
                                                            <div>{!!runner_bk.back[0] && parseFloat(runner_bk.back[0].price) !== 0 && is_active ? (runner_bk.back[0].price.indexOf('.') > -1 ? runner_bk.back[0].price.substring(0, (runner_bk.back[0].price.indexOf('.') + 3)) : runner_bk.back[0].price) : ""}</div>
                                                        </a>
                                                    </div>}
                                                </div>
                                            </div>
                                        </div>}
                                    </>
                                )
                            })}
                        </div>
                        <table className="table w-100 game-list-col eventdetails bets mb-0">
                            <tbody>
                                {!!this.props.msgMarket && this.state.mktMsg === '' &&
                                    <tr className="">
                                        <td colSpan="2"><span className="fancymassage float-right bmmassage"><i className="fa fa-envelope mr-1"></i> {this.props.msgMarket}</span></td>
                                    </tr>
                                }
                                {this.state.mktMsg !== '' &&
                                    <tr className="">
                                        <td colSpan="2"><span className="fancymassage float-right bmmassage"><i className="fa fa-envelope mr-1"></i> {this.state.mktMsg}</span></td>
                                    </tr>
                                }
                                {
                                    this.props.selected_market === market.marketId &&
                                    <BetForm loadingBet={this.props.loadingBet} notify={(msg, type) => { this.props.notify(msg, type) }} eventMarket={market} selcted_bet_option={this.props.selcted_bet_option} curBets={this.props.curBets} updateExpo={(expo) => { this.updateExpo(expo) }} selectionId={this.state.selectionId} runner_name={this.state.runner_name} bid_at={this.state.bid_at} betForm={this.props.betForm} addBet={(data) => { this.addBetFn(data, market) }} />
                                }
                            </tbody>
                        </table>
                    </div>
                }
            </>
        )
    }
}
